import React from "react";
import { AiOutlinePlus } from "react-icons/ai";
import { BiChevronLeft, BiChevronRight } from "react-icons/bi";
import { FiSettings } from "react-icons/fi";
import { Link } from "react-router-dom";
import LocationTable from "./LocationTable";
import { Pagination } from "antd";

function LocationList({ data, getLocationData, onChangeVal, initialVlue, handleChange, reset }) {
  return (
    <div className="pageTableWrapper">
      <div className="pageHeader">
        <div className="pageTitle">
          <FiSettings />
          <h5>Location / City</h5>
        </div>
        <div className="addNew">
          <Link to="/admin/add-location" className="btn btn-success">
            <AiOutlinePlus /> Add New Location / City
          </Link>
        </div>
      </div>

      <div className="pageBody">
        <LocationTable data={data} getLocationData={getLocationData} initialVlue={initialVlue} handleChange={handleChange} reset={reset} />
      </div>

      <div className="pageFooter">
        <div className="row">
          <div className="col-md-6">
            <div className="showEntry">
              <p>Showing {data?.totalCount} entries</p>
            </div>
          </div>
          <div className="col-md-6">
            <Pagination
              defaultCurrent={1}
              onChange={onChangeVal}
              total={data?.totalCount}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default LocationList;
